






























































import { Prop, Component, Vue, Watch } from "vue-property-decorator";
import { Getter, Action } from "vuex-class";
import { deleteRecording } from "@/api";
import {
  LearnerRecordings,
  Recording,
  Status
} from "../../types/LearnerRecordings";
@Component({
  components: {}
})
export default class Recordings extends Vue {
  @Getter private JWT!: string;
  @Getter private learnerRecordings?: LearnerRecordings;
  @Action private fetchLearnerRecordings: any;
  @Action private setDisplayError: any;
  private isLoading = true;
  private perPage = 10;
  private currentPage = 1;
  private selectedRecordings: string[] = [];
  private deleteModalShow: boolean = false;
  private fields = [
    { key: "selected", label: "", sortable: false },
    {
      key: "title",
      label: "Title",
      sortable: true
    },
    {
      key: "duration",
      sortable: true
    },
    {
      key: "dateCreated",
      label: "Date",
      sortable: true,
      formatter: (value: Date, key: any, item: any) => {
        value = new Date(value);
        return `${value.getMonth() +
          1}/${value.getDate()}/${value.getFullYear()}`;
      }

      // Variant applies to the whole column, including the header and footer
      // variant: "danger"
    },
    {
      key: "status",
      sortable: false
    }
  ];

  private created() {
    this.fetchLearnerRecordings();
    console.log("fetching");
  }

  private rowClicked(item: Recording) {
    if (item.status == Status.Completed) {
      this.$router.push({ name: "learnerresults", params: { sid: item.sid } });
    }
  }

  private selectRecording(sid: string) {
    let index = this.selectedRecordings.indexOf(sid);
    if (index > -1) {
      this.selectedRecordings.splice(index, 1);
    } else {
      this.selectedRecordings.push(sid);
    }
  }

  @Watch("learnerRecordings")
  private onLearnerRecordings() {
    
    this.isLoading = false;
  }

  private handleDelete() {
    this.deleteModalShow = false;
    for (let sessionID of this.selectedRecordings) {
      deleteRecording(
        this.JWT,
        sessionID,
        (response: any) => {
          let selectedIndex = this.selectedRecordings.findIndex(sid => sid === sessionID);
          this.selectedRecordings.splice(selectedIndex, 1);
          if (this.learnerRecordings) {
            let recordingIndex = this.learnerRecordings.recordings.findIndex(
              recording => recording.sid === sessionID
            );
            if (recordingIndex > -1) {
              this.learnerRecordings.recordings.splice(recordingIndex, 1);
            }
          }
        },
        (error: string) => {
          this.setDisplayError(error);
        }
      );
    }
  }
}
